const scores = (state = {}, action) => {
    switch (action.type) {
        case "SET_HIGH_SCORES": {
            return Object.assign( {}, state, { highscores: action.highScores } );
        }
		default:
            return state
    }
}
  
export default scores


// WEBPACK FOOTER //
// ./src/reducers/scores.js